import dayjs from "dayjs";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
export var CustomerHistoryMobileView = [{
        type: FormItemTypes.Box,
        name: '',
        sx: {
            bgcolor: 'secondary.50'
        },
        padding: '12px ',
        margin: '12px',
        gap: '16px',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Effective from date:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'text.tertiary'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'EffectiveFROM',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        color: 'text.primary',
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.EffectiveFROM) {
                                var EffectiveFromDate = formData !== null && formData !== void 0 && formData.EffectiveFROM ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.EffectiveFROM).format('DD MMM, YYYY') : '-';
                                return EffectiveFromDate;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                justifyContent: 'space-between',
                alignItems: 'end',
                elements: [{
                        type: FormItemTypes.Typography,
                        name: '',
                        children: 'Effective to date:',
                        columnSize: 0,
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        color: 'text.tertiary'
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'EffectiveTo',
                        fontWeight: 'medium',
                        fontSize: 'sm',
                        columnSize: 0,
                        color: 'text.primary',
                        valueGetter: function (formData) {
                            if (formData !== null && formData !== void 0 && formData.EffectiveTo) {
                                var EffectiveToDate = formData !== null && formData !== void 0 && formData.EffectiveTo ? dayjs.utc(formData === null || formData === void 0 ? void 0 : formData.EffectiveTo).format('DD MMM, YYYY') : '-';
                                return EffectiveToDate;
                            }
                            else {
                                return '-';
                            }
                        }
                    }]
            }]
    }];
